"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.company = exports.website = void 0;
exports.website = 'https://endeavour.nl';
exports.company = 'Endeavour Platforms';
//# sourceMappingURL=config.js.map